<script type="text/jsx" lang="jsx">
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import EditSimple from './edit-simple.vue';
import EditDelta from './edit-delta.vue';
import Add from './add.vue';
import Trial2Paid from './trial2paid.vue';
import planPropsMixin from '@/plans/mx/plan-props';
import planCommonMixin from '@/plans/LARGE_MEETING/mixin';
import { isAutoAddable } from '@/plans/ZOOM_MEETING/common/utils';

export default {
  mixins: [planPropsMixin, planCommonMixin],
  render() {
    if (this.$context.is.add2cart) return <Add {...this.$attrs} />;
    if (this.$context.is.edit) {
      if(this.$context.is.simplify){
        return <EditSimple />;
      }
      if (this.$context.is.addQty && isAutoAddable()) {
        return <EditDelta {...this.$attrs} />;
      } else {
        return <Edit {...this.$attrs} />;
      }
    }
    if (this.$context.is.buyNow || this.$context.is.basic2pro || this.$context.is.biz2pro || this.$context.is.downgrade) return <BuyNow {...{...this.$props, ...this.$attrs }} />;
    if (this.$context.is.trial2paid) return <Trial2Paid {...{...this.$props, ...this.$attrs }} />
    return null;
  },
};
</script>
